import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { accountTypes } from 'config/user.type.constants'
import { requestedToParties } from 'pages/LoanSubmission/constants'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { getAdminConfig, getAdminEmails, setAdminConfig } from 'services'
import { ButtonGroup } from 'stories/components'
import { InputConvert } from 'utils'
import { RenderInput } from 'utils/RenderInput'

import { getRulesConfigurationFields } from './constants'

const notificationConfigKeys = [
  'borrowerAutoNotifyLoanStatus',
  'borrowerAutoNotifyFrequency',
  'borrowerAutoNotifyTime',
  'borrowerAutoNotifyLoanTypes',
]
export const RulesConfiguration = () => {
  const { loanGlobalStatus } = useSelector((state: any) => ({
    loanGlobalStatus: state.loanGlobalStatus,
  }))

  const [inputs, setInputs] = useState<Record<string, any>>(getRulesConfigurationFields(loanGlobalStatus))
  const [isLoading, setLoading] = useState(true)
  const [data, setData] = useState<Record<string, any>>({})
  const [adminEmails, setAdminEmails] = useState<string[]>([])
  const [partyTab, setPartyTab] = useState('Borrower')

  useEffect(() => {
    getAdminConfig('rules')
      .then((rulesConfig) => {
        setData(rulesConfig)
        let newInputs = cloneDeep(inputs)
        Object.keys(inputs).forEach((key) => {
          newInputs[key].value = rulesConfig[key] ?? ''
        })
        setInputs(newInputs)
      })
      .finally(() => setLoading(false))

    getAdminEmails().then((emails: string[]) => setAdminEmails(emails))
  }, [])

  const assigneeOptions = useMemo(() => {
    const options = { ...accountTypes }
    adminEmails.forEach((email) => (options[email] = email))
    return options
  }, [adminEmails])

  const onChange = (key: string, value: any) => {
    if (notificationConfigKeys.includes(key)) {
      const temp = cloneDeep(data)
      if (!temp.notification[partyTab]) temp.notification[partyTab] = {}
      temp.notification[partyTab][key] = value
      setData(temp)
    }
    const newInputs = cloneDeep(inputs)
    newInputs[key].value = InputConvert(newInputs[key], value)
    newInputs[key].error = ''
    setInputs(newInputs)
  }

  const onSubmit = async () => {
    const json: Record<string, any> = {}
    Object.keys(inputs).map((key) => {
      if (inputs[key].inputType === 'section') return
      json[key] = inputs[key].value
    })
    json.notification = data.notification
    notificationConfigKeys.map((key) => delete json[key])

    setLoading(true)
    await setAdminConfig('rules', json)
    setLoading(false)
  }

  return (
    <div className="relative">
      <LayoutLoading show={isLoading} />

      <div className="grid grid-cols-1 md:grid-cols-2 sm:gird-cols-2 gap-2">
        {Object.keys(inputs).map((key, index) => {
          const item = inputs[key]
          if (notificationConfigKeys.includes(key)) {
            item.value = data?.notification?.[partyTab]?.[key]
          }

          if (key === 'emailWithdrawnLoans') {
            ;(item as any).options = assigneeOptions
          }

          const rtl = [
            <div className={`input md:col-span-${item.span || 1} `} key={index}>
              <RenderInput input={item} Key={key} onChange={onChange} onBlur={onSubmit} />
            </div>,
          ]
          if (key === 'unClearWhenNewDocument') {
            rtl.push(
              <div className="col-span-full">
                <ButtonGroup title={requestedToParties} value={partyTab} onChange={setPartyTab} />
              </div>,
            )
          }

          return rtl
        })}
      </div>
    </div>
  )
}
